/**
 *
 * Created by zt on 2019/02/21.
 *
 * 场景： js处理精度会出现点问题 小数计算时容易出现 eg 分摊
 *
 * 有后续的场景可自行优化更新 也可联系本人更改
 *
 */
export default {
  /*
   * 判断obj是否为一个整数
   */
  isInteger(obj) {
    return Math.floor(obj) === obj;
  },
  /*
   * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
   * @param floatNum {number} 小数
   * @return {object}
   *   {times:100, num: 314}
   */
  toInteger(floatNum) {
    let ret = { times: 1, num: 0 };
    if (this.isInteger(floatNum)) {
      ret.num = floatNum;
      return ret;
    }
    let strfi = floatNum + '';
    if (/^\d+e[+-]\d+$/.test(strfi)) {
      strfi.replace(/^(\d+)e([+-]\d+)$/, (target, $1, $2) => {
        ret.times = Math.pow(10, Math.abs($2));
        ret.num = $1;
      });
      return ret;
    }
    let dotPos = strfi.indexOf('.');
    let len = strfi.substr(dotPos + 1).length;
    let times = Math.pow(10, len);
    let intNum = parseInt(floatNum * times + 0.5, 10);
    if (strfi.indexOf('-') > -1) {
      intNum -= 1;
    }
    ret.times = times;
    ret.num = intNum;
    return ret;
  },
  /*
   * 核心方法，实现加减乘除运算，确保不丢失精度
   * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
   *
   * @param a {number} 运算数1
   * @param b {number} 运算数2
   * @param digits {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
   * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
   *
   */
  operation(a, b, op) {
    let o1 = this.toInteger(a);
    let o2 = this.toInteger(b);
    let { num: n1, times: t1 } = o1;
    let { num: n2, times: t2 } = o2;
    let max = t1 > t2 ? t1 : t2;
    let result = null;
    switch (op) {
      case 'add':
        if (t1 === t2) {
          // 两个小数位数相同
          result = n1 + n2;
        } else if (t1 > t2) {
          // o1 小数位 大于 o2
          result = n1 + n2 * (t1 / t2);
        } else {
          // o1 小数位 小于 o2
          result = n1 * (t2 / t1) + n2;
        }
        return result / max;
      case 'subtract':
        if (t1 === t2) {
          result = n1 - n2;
        } else if (t1 > t2) {
          result = n1 - n2 * (t1 / t2);
        } else {
          result = n1 * (t2 / t1) - n2;
        }
        return result / max;
      case 'multiply':
        result = (n1 * n2) / (t1 * t2);
        return result;
      case 'divide':
        return this.operation(n1 / n2, t2 / t1, 'multiply');
    }
  },
  // 加减乘除的四个接口
  add(a, b) {
    return this.operation(a, b, 'add');
  },
  // 减
  subtract(a, b) {
    return this.operation(a, b, 'subtract');
  },
  // 乘
  multiply(a, b) {
    return this.operation(a, b, 'multiply');
  },
  // 除
  divide(a, b) {
    return this.operation(a, b, 'divide');
  },
};
